import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, WA_LINK } from "../lib/site";

export const Logo = ({ compact = false }) => (
    <a href="#top" className="flex items-center gap-2.5 group" data-testid="logo-home-link">
        <img src="/favicon.svg" alt="Edil Loffredo" className="w-8 h-8" />
        {!compact && (
            <span className="font-display font-bold tracking-tight text-lg leading-none text-cloud">
                EDIL LOFFREDO
                <span className="block font-mono2 font-medium text-[9px] tracking-[0.3em] text-aqua uppercase mt-0.5">
                    Impermeabilizzazioni
                </span>
            </span>
        )}
    </a>
);

export const WaButton = ({ className = "", children }) => (
    <a
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="cta-whatsapp"
        className={`inline-flex items-center justify-center gap-2.5 bg-wa text-bitume font-semibold tracking-tight px-6 py-4 frame-clipped-sm transition-all duration-300 hover:brightness-110 hover:-translate-y-0.5 ${className}`}
    >
        <MessageCircle className="w-5 h-5" strokeWidth={2.2} />
        {children || "Contattaci su WhatsApp"}
    </a>
);

export const CallButton = ({ className = "", children }) => (
    <a
        href={`tel:${PHONE_TEL}`}
        data-testid="cta-call"
        className={`inline-flex items-center justify-center gap-2.5 border border-white/15 text-cloud font-semibold tracking-tight px-6 py-4 frame-clipped-sm transition-all duration-300 hover:border-aqua hover:text-aqua ${className}`}
    >
        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/><path d={`M14.05 2a9 9 0 0 1 8 7.94M14.05 6A5 5 0 0 1 18 10`} /></svg>
        {children || `Chiama ora · ${PHONE_DISPLAY}`}
    </a>
);

export const QuoteButton = ({ className = "", children }) => (
    <a
        href="#contatti"
        data-testid="cta-quote"
        className={`inline-flex items-center justify-center gap-2.5 bg-ambra text-bitume font-semibold tracking-tight px-6 py-4 frame-clipped-sm transition-all duration-300 hover:brightness-110 hover:-translate-y-0.5 ${className}`}
    >
        {children || "Richiedi un preventivo"}
    </a>
);

export const fadeSlide = {
    hidden: { opacity: 0, y: 24 },
    show: (i) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] },
    }),
};

export { motion };
